module.exports = __webpack_public_path__ + "static/media/sort-numeric-up.a793d33c.svg";